// @flow

import type { AbsenceMonitoringState } from "./types";

export const initialState: AbsenceMonitoringState = {
  requestsInProgress: 0,
  schema: {},
  list: [],
  current: null,
  draft: null,
  assignments: [],
  draftAssignments: [],
};

export default initialState;
